import GeoJSONPolyline from 'geojson-polyline';
import request from "request";
import "./main.css";
import route from './route.json';
import waypoints from './waypoints.json';
// import CurrentsControl from './CurrentsControl';
import PlasticControl from './PlasticControl';
import ScienceControl from './ScienceControl';
// import WindControl from './WindControl';

mapboxgl.accessToken = "pk.eyJ1IjoiZXh4cGVkaXRpb24iLCJhIjoiY2swd3FoZDNsMDA0MjNpcGt0Ympod3BlYSJ9.AEqq3h_N90zZHQ5TOflDDw";

// GET tracker data as encoded geojson before doing anything else
request('https://ar2.zerosixzero.org/api/poly/exxpedition2019', (error, response, body) => {
  if (error) console.error("API Error: ", error);

  const trackline = GeoJSONPolyline.decode(JSON.parse(body || {}));
  const currentPosition = trackline.geometry.coordinates[trackline.geometry.coordinates.length - 1] || [-4.132875, 50.368294];
  // const heading = trackline.properties.heading

  window.map = new mapboxgl.Map({
    container: 'map',
    style: 'mapbox://styles/exxpedition/ck1r3bxx60bi51cp89pbva947',
    center: currentPosition,
    zoom: 2,
    scrollZoom: window === window.parent,
    bearing: 0,
    pitch:0,
    preserveDrawingBuffer: new URLSearchParams(window.location.search).get('screenshot') || false
  });

  function addMarkers() {
    map.loadImage('https://static.z6z.co/static/markers/exx_209_500.png', function(error, image) {
      if (error) throw error;
      map.addImage('marker', image);
      map.addLayer({
        "id": "marker",
        "type": "symbol",
        "source": {
          "type": "geojson",
          "data": {
            "type": "Feature",
            "geometry": {
              "type": "Point",
              "coordinates": currentPosition
            },
          },
        },
        "layout": {
          "icon-allow-overlap": true,
          "icon-anchor": "top-left",
          "icon-ignore-placement": true,
          "icon-image": "marker",
          "icon-offset": [-18,-3].map(function(xy) { return xy*image.width/28 }),
          "icon-pitch-alignment": "viewport",
          "icon-rotate": 90,
          "icon-rotation-alignment": "map",
          "icon-size": [
            "interpolate",
            ["linear"],
            ["zoom"],
            1,
            20/image.width,
            2.5,
            28/image.width
          ],
        },
      });


    });
  }

  function addTrackLines() {
    map.addSource('route',{
      type: 'geojson',
      data: route
    });

    map.addSource('current_track',{
      type: 'geojson',
      lineMetrics: true,
      data: trackline
    });

    map.addLayer({
      "id": "routeline",
      "type": "line",
      "source": "route",
      "layout": {
        "line-join": "round",
        "line-cap": "round"
      },
      "paint": {
        "line-color": "red",
        "line-dasharray": [0, 3],
        "line-width": 2,
        'line-opacity': 1,
      }
    });

//     map.addLayer({
//       "id": "route-label",
//       "type": "symbol",
//       "source": "route",
//       "layout": {
//           "symbol-placement": "line",
//           "text-field": 'Virtual Voyage Route',
//           "text-size": 16
//       },
//       "paint": {
//         "text-color": "white"
//       }
//   });

//   map.addLayer({
//     "id": "route-label",
//     "type": "symbol",
//     "source": "current_track",
//     "layout": {
//         "symbol-placement": "line",
//         "text-field": 'Sailing Route of S.V Traveledge',
//         "text-size": 32
//     },
//     "paint": {
//       "text-color": "white"
//     }
// });

    map.addLayer({
      "id": "trackline",
      "type": "line",
      "source": "current_track",
      "layout": {
        "line-join": "round",
        "line-cap": "round"
      },
      "paint": {
        "line-color": "#f71049",
        "line-width": 3,
        'line-gap-width': 0,
        'line-opacity': 0.8,
      }
    });
  };

  // The following values can be changed to control rotation speed:
 
// At low zooms, complete a revolution every two minutes.
const secondsPerRevolution = 120;
// Above zoom level 5, do not rotate.
const maxSpinZoom = 5;
// Rotate at intermediate speeds between zoom levels 3 and 5.
const slowSpinZoom = 3;
 
let userInteracting = false;
let spinEnabled = true;
 
function spinGlobe() {
const zoom = map.getZoom();
if (spinEnabled && !userInteracting && zoom < maxSpinZoom) {
let distancePerSecond = 360 / secondsPerRevolution;
if (zoom > slowSpinZoom) {
// Slow spinning at higher zooms
const zoomDif =
(maxSpinZoom - zoom) / (maxSpinZoom - slowSpinZoom);
distancePerSecond *= zoomDif;
}
const center = map.getCenter();
center.lng -= distancePerSecond;
// Smoothly animate the map over one second.
// When this animation is complete, it calls a 'moveend' event.
map.easeTo({ center, duration: 1000, easing: (n) => n });
}
}
 
// Pause spinning on interaction
map.on('mousedown', () => {
userInteracting = true;
});
 
// These events account for cases where the mouse has moved
// off the map, so 'mouseup' will not be fired.
map.on('dragend', () => {
userInteracting = true;
});
map.on('pitchend', () => {
userInteracting = true;
spinGlobe();
});
map.on('rotateend', () => {
userInteracting = false;
spinGlobe();
});
 
// When animation is complete, start spinning if there is no ongoing interaction
map.on('moveend', () => {
spinGlobe();
});
 
spinGlobe();

  map.on('load', () => {
    // Add navigation and wind controls
    const fullscreen = new mapboxgl.FullscreenControl();
    const fullscreenSupport = fullscreen._checkFullscreenSupport();

    // Add fullscreen button for iOS (opens z6z directly in a new tab)
    if (!fullscreenSupport) {
      fullscreen._onClickFullscreen = () => window.open('https://z6z.co/exxpedition');
      fullscreen._checkFullscreenSupport = () => true;
    }

    // Enable scrollZoom for fullscreened iframes
    if (window !== window.parent) {
      document.addEventListener('fullscreenchange', function() {
        document.fullscreenElement ? map.scrollZoom.enable() : map.scrollZoom.disable();
      });
    }

    const nav = new mapboxgl.NavigationControl({ showCompass: false });
    // const wind = new WindControl();
    // const currents = new CurrentsControl();
    const plastic = new PlasticControl();
    const science = new ScienceControl();
    map.addControl(nav, 'top-left');
    map.addControl(fullscreen, 'top-left');
    // map.addControl(wind, 'top-left');
    // map.addControl(currents, 'top-left');
    map.addControl(plastic, 'top-left');
    map.addControl(science, 'top-left');

    // addMarkers();
    addTrackLines();

    // legend
    const routeItem = document.createElement('div');
    const routeKey = document.createElement('span');
    routeKey.className = 'legend-key';
    routeKey.style.borderBottom = '2px solid red'
  
    const routeValue = document.createElement('span');
    routeValue.innerHTML = "Sailing Route of S.V Traveledge";
    routeItem.appendChild(routeKey);
    routeItem.appendChild(routeValue);
    legend.appendChild(routeItem);

    const virtualItem = document.createElement('div');
    const virtualKey = document.createElement('span');
    virtualKey.className = 'legend-key';
    virtualKey.style.borderBottom = '2px dotted red'

    const virtualValue = document.createElement('span');
    virtualValue.innerHTML = "Virtual Voyage Route";
    virtualItem.appendChild(virtualKey);
    virtualItem.appendChild(virtualValue);
    legend.appendChild(virtualItem);


    // Add waypoints
    waypoints.features.filter(point => point.properties.keep == true).forEach(feature => {
      // create a HTML element for each feature
      const el = document.createElement('div');
      el.className = 'marker';
      if (feature.properties.arrived) {
        el.className += ' arrived';
      }
      var popup = new mapboxgl.Popup(
        {
          anchor: 'bottom',
          offset: 18/4,
        }
      )
      .setHTML(
        '<div class="location">' + feature.properties.location + '</div>' +
        '<div>' + feature.properties.info + '</div>'
      );

      // make a marker for each feature and add to the map
      new mapboxgl.Marker(el)
        .setLngLat(feature.geometry.coordinates)
        .setPopup(popup)
        .addTo(map);
    });
  });
});
